/* eslint-disable import/prefer-default-export */
export const latestQuotationQueryKeys = {
    quotations:(filters: any) => ["quotations", filters],
  };